export class LogIdRequest{
    productionLogid:number;
    constructor(productionLogid:number){
        this.productionLogid = productionLogid;
    }
}